import React, { useState } from 'react';

import { Tag } from 'primereact/tag';
import { InputTextarea } from "primereact/inputtextarea";

import useSelectedCompanyStore from '../../../store/useSelectedCompanyStore';

const StepFour = ({ data }) => {
    const { basicInfosObject, quizObject, selectedTests } = data;
    const [expanded, setExpanded] = useState({});

    const selectedCompany = useSelectedCompanyStore((state) => state.selectedCompany);

    const questionTypeOptions = [
        { label: 'Choix multiples', value: 'mcq-m' },
        { label: 'Choix unique', value: 'mcq-u' },
        { label: 'Réponse courte', value: 'short' },
        { label: 'Réponse longue', value: 'long' },
        { label: 'Choix unique (Likert)', value: 'likert' },
    ];

    const toggleExpand = (id) => {
        setExpanded(prevExpanded => ({ ...prevExpanded, [id]: !prevExpanded[id] }));
    };

    const renderField = (label, value) => (
        <div className="recap-item">
            <label className="label">{label}</label>
            <p>{value || 'Vide'}</p>
        </div>
    );

    const renderQuestions = (questions) => (
        questions.map((question, questionIndex) => (
            <div key={question.id} className="box radius-10 mt-2">
                <p><strong>Question {questionIndex + 1} :</strong> {question.question}</p>
                <p><strong>Type :</strong> {questionTypeOptions.find(option => option.value === question.type)?.label || ''}</p>
                {['mcq-m', 'mcq-u'].includes(question.type) && question.choices.length > 0 && (
                    <div>
                        <p><strong>Choix :</strong></p>
                        <ul>
                            {question.choices.map((choice, choiceIndex) => (
                                <div key={`mcq-question-${choiceIndex}`}>
                                    {choice.length > 0 &&
                                        <li key={`mqc-li-${choiceIndex}`}>{choice}</li>
                                    }
                                </div>
                            ))}
                        </ul>
                    </div>
                )}

                {question?.type === 'likert' && question.choices.length > 0 && (
                    <div className="likert-scale-container">
                        <table className="table is-striped is-hoverable is-fullwidth">
                            <thead className='has-text-centered'>
                                <tr>
                                    <th>Question</th>
                                    <th>Strongly Disagree</th>
                                    <th>Disagree</th>
                                    <th>Neutral</th>
                                    <th>Agree</th>
                                    <th>Strongly Agree</th>
                                </tr>
                            </thead>
                            <tbody>
                                {question.choices.map((choice, choiceIndex) => (
                                    <tr key={choiceIndex}>
                                        <td><InputTextarea autoResize className='p-2' value={choice} rows={3} cols={30} readOnly /></td>
                                        {[1, 2, 3, 4, 5].map((num) => (
                                            <td key={num} style={{ textAlign: 'center' }}>
                                                <input
                                                    type="radio"
                                                    name={`likert-${question.id}-${choiceIndex}`}
                                                    value={num}
                                                    disabled
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>
        ))
    );

    return (
        <section id="step-recap" className='container section pt-0 mt-0'>
            <h2>Informations Générales</h2>
            <div className="recap-section">
                {renderField('Nom de la campagne', basicInfosObject.campaign_name)}
                {renderField('Langue de la campagne', basicInfosObject.language)}
                {renderField('Entreprise', selectedCompany?.name)}
                {renderField('Responsable en charge de la campagne', basicInfosObject.recruiter_label)}
            </div>

            <hr />

            {quizObject.length > 0 && (<>
                <h2>Questions de Pré-qualification</h2>
                {quizObject.map((page, pageIndex) => (
                    <div key={page.id} className="box radius-20">
                        <div className="media-content">
                            <p onClick={() => toggleExpand(page.id)} className="is-clickable">
                                <strong>
                                    Page - {pageIndex + 1} {page.title}
                                    <span className="icon is-small is-pulled-right">
                                        <i className={`fas fa-chevron-${expanded[page.id] ? 'down' : 'right'}`}></i>
                                    </span>
                                </strong>
                            </p>
                            {expanded[page.id] && renderQuestions(page.questions)}
                        </div>
                    </div>
                ))}

                <hr />

            </>)}

            <h2>Tests Sélectionnés</h2>
            <div className="tags">
                {selectedTests.selectedTests.map((test) => {
                    const testColor = (test.test_color && test.test_color !== '#FFFFFF') ? test.test_color : '#4786C6';
                    return (
                        <Tag key={test.ref} className='selected_test__tag mt-1'
                            style={{
                                background: `linear-gradient(90deg, ${testColor}, ${testColor + '63'})`,
                                borderColor: testColor,
                                cursor: 'default'
                            }}>
                            <span>{test.title}</span>
                        </Tag>
                    );
                })}
            </div>
        </section>
    );
};

export default StepFour;